export const mockSupplierLocations = [
  {
    id: '1',
    name: 'Elite Catering Co.',
    role: 'Catering',
    status: 'on-site' as const,
    isSharing: true,
    lastUpdate: '2 mins ago',
    phone: '+44 7700 900123'
  },
  {
    id: '2',
    name: 'ProSound AV',
    role: 'Audio Visual',
    status: 'en-route' as const,
    eta: '14:45',
    distance: '3.2 miles',
    isSharing: true,
    lastUpdate: '30 secs ago',
    phone: '+44 7700 900456'
  },
  {
    id: '3',
    name: 'Bloom Florals',
    role: 'Florist',
    status: 'wrong-site' as const,
    distance: '8.5 miles',
    isSharing: true,
    lastUpdate: '1 min ago',
    phone: '+44 7700 900789'
  },
  {
    id: '4',
    name: 'Event Lighting Ltd',
    role: 'Lighting',
    status: 'en-route' as const,
    eta: '15:10',
    distance: '5.1 miles',
    isSharing: true,
    lastUpdate: '45 secs ago',
    phone: '+44 7700 900321'
  },
  {
    id: '5',
    name: 'City Bar Services',
    role: 'Bar Service',
    status: 'unknown' as const,
    isSharing: false,
    phone: '+44 7700 900654'
  },
  {
    id: '6',
    name: 'Stage & Set Design',
    role: 'Stage Setup',
    status: 'on-site' as const,
    isSharing: true,
    lastUpdate: '5 mins ago',
    phone: '+44 7700 900987'
  }
];

export const mockComplianceData = [
  {
    id: '1',
    name: 'Elite Catering Co.',
    role: 'Catering',
    overallStatus: 'compliant' as const,
    requirements: [
      { id: 'r1', name: 'Public Liability Insurance (£10m)', status: 'approved' as const },
      { id: 'r2', name: 'Food Safety Level 2', status: 'approved' as const },
      { id: 'r3', name: 'Allergen Certificate', status: 'approved' as const },
      { id: 'r4', name: 'Risk Assessment', status: 'approved' as const }
    ]
  },
  {
    id: '2',
    name: 'ProSound AV',
    role: 'Audio Visual',
    overallStatus: 'partial' as const,
    requirements: [
      { id: 'r1', name: 'Public Liability Insurance (£5m)', status: 'warning' as const, expiryDate: '28 Aug' },
      { id: 'r2', name: 'PAT Testing Certificate', status: 'approved' as const },
      { id: 'r3', name: 'Risk Assessment', status: 'approved' as const },
      { id: 'r4', name: 'Method Statement', status: 'approved' as const }
    ]
  },
  {
    id: '3',
    name: 'Bloom Florals',
    role: 'Florist',
    overallStatus: 'non-compliant' as const,
    requirements: [
      { id: 'r1', name: 'Public Liability Insurance (£2m)', status: 'missing' as const },
      { id: 'r2', name: 'Risk Assessment', status: 'missing' as const },
      { id: 'r3', name: 'Waste Management Certificate', status: 'approved' as const }
    ]
  },
  {
    id: '4',
    name: 'Event Lighting Ltd',
    role: 'Lighting',
    overallStatus: 'compliant' as const,
    requirements: [
      { id: 'r1', name: 'Public Liability Insurance (£5m)', status: 'approved' as const },
      { id: 'r2', name: 'PAT Testing Certificate', status: 'approved' as const },
      { id: 'r3', name: 'Working at Height Certificate', status: 'approved' as const },
      { id: 'r4', name: 'Risk Assessment', status: 'approved' as const }
    ]
  },
  {
    id: '5',
    name: 'City Bar Services',
    role: 'Bar Service',
    overallStatus: 'partial' as const,
    requirements: [
      { id: 'r1', name: 'Public Liability Insurance (£5m)', status: 'approved' as const },
      { id: 'r2', name: 'Personal License', status: 'warning' as const, expiryDate: '5 Sep' },
      { id: 'r3', name: 'Food Safety Level 2', status: 'approved' as const },
      { id: 'r4', name: 'Risk Assessment', status: 'approved' as const }
    ]
  }
];